var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "10"
    }
  }, [_c('form-tanggal', {
    on: {
      "submit": _vm.submit
    }
  }), _vm.profitLossContent ? _c('b-card', [_c('div', {
    staticClass: "d-flex justify-content-end mb-2"
  }, [_c('b-dropdown', {
    attrs: {
      "variant": "outline-primary",
      "text": "Download",
      "right": "",
      "disabled": !_vm.profitLossContent
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.download('pdf');
      }
    }
  }, [_vm._v(" Export ke PDF ")]), _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.download('excel');
      }
    }
  }, [_vm._v(" Export ke Excel ")])], 1)], 1), _c('section', {
    attrs: {
      "id": "table-content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.profitLossContent)
    }
  })]) : _c('div', {
    staticClass: "alert alert-danger p-1"
  }, [_vm._v(" Harap pilih tanggal awal & tanggal akhir ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }